import axios from "../../axios";

export function session__count_online() {
    return (async (dispatch) => {
        try {
            let response = await axios.get(`Sessions/count?where=${encodeURIComponent(JSON.stringify({
                and: [
                    { logOut: null },
                    { active: true }
                ]
            }))}`);
            dispatch({
                type: "SESSION_ONLINE_FULFILLED",
                payload: {
                    data: response.data,
                    error: null
                }
            });
        }
        catch (e) {
            dispatch({
                type: "SESSION_ONLINE_REJECTED",
                payload: {
                    data: null,
                    error: e
                }
            });
        }
    });
}



// WEBPACK FOOTER //
// ./src/redux/actions/sessions.js